import { Component, type ErrorInfo, type JSX, type ReactNode } from 'react';

/**
 * Faengt Fehler beim Aufbau der Oberflaeche ab (ERR-01, ERR-11).
 *
 * Ohne dieses Netz nimmt ein Fehler waehrend des Renderns den ganzen Baum mit:
 * React haengt die Wurzel aus, und uebrig bleibt eine WEISSE SEITE ohne Text.
 * Das ist genau der Fall, gegen den ERR-11 geschrieben ist — "unerwartete
 * Fehler fuehren nie zu Datenverlust im Formular" —, und ohne Netz fuehrt er
 * zum Totalverlust statt zur Wiederherstellung.
 *
 * Die Meldung traegt die drei Teile aus ERR-01. Der Wortlaut der Ausnahme
 * gehoert NICHT hinein (ERR-12): Er kann Feldinhalte enthalten, und dem
 * Anwender sagt "Cannot read properties of undefined" nichts. Er geht in die
 * Entwicklerkonsole.
 *
 * Eine Klassenkomponente, weil React Fehlergrenzen nur so anbietet — es gibt
 * bis heute keinen Haken dafuer.
 */
export class Auffangnetz extends Component<
  {
    readonly children: ReactNode;
    /**
     * IM RAHMEN (ÄA-41): Das Netz steht um die Maske und nicht um die ganze
     * Oberfläche. Scheitert eine Maske, bleiben Kopf- und Menüzeile stehen —
     * man kommt mit einem Klick woandershin, statt neu laden zu müssen. Der
     * Rahmen trägt schon `<main>` und die Überschrift; das Netz meldet sich
     * dann als Abschnitt darin.
     */
    readonly eingebettet?: boolean;
  },
  { readonly gefallen: boolean }
> {
  override state = { gefallen: false };

  static getDerivedStateFromError(): { gefallen: boolean } {
    return { gefallen: true };
  }

  override componentDidCatch(fehler: Error, angaben: ErrorInfo): void {
    // Nur in die Konsole. Ein Meldeweg zum Server gehoert hierher, sobald es
    // einen gibt — dann traegt der Eintrag die Vorgangskennung und der Support
    // findet ihn (LOG-01, ERR-02).
    console.error('Aufbau der Oberflaeche gescheitert', fehler, angaben.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.gefallen) return this.props.children;

    if (this.props.eingebettet === true) {
      return (
        <div className="meldung meldung--fehler" role="alert">
          <p className="meldung__was">Diese Maske ist beim Aufbau abgebrochen.</p>
          <p className="meldung__auswirkung">
            Es wurde nichts gespeichert und nichts geändert. Die übrigen Masken sind über das
            Menü weiter erreichbar.
          </p>
          <p className="meldung__schritt">
            Laden Sie die Seite neu. Bleibt es dabei, wenden Sie sich an die Administration.
          </p>
          <JSXNeuladen />
        </div>
      );
    }

    return (
      <main className="maske" aria-labelledby="netz-titel">
        <h1 id="netz-titel">Die Anzeige ist abgebrochen</h1>
        <div className="meldung meldung--fehler" role="alert">
          <p className="meldung__was">
            Beim Aufbau dieser Seite ist etwas schiefgegangen.
          </p>
          <p className="meldung__auswirkung">
            Es wurde nichts gespeichert und nichts geändert. Was Sie in ein Formular
            eingetragen hatten, liegt noch im Zwischenspeicher dieses Tabs und steht
            nach dem Neuladen wieder zur Verfügung — Kennwörter ausgenommen, die
            werden bewusst nie zwischengespeichert.
          </p>
          <p className="meldung__schritt">
            Laden Sie die Seite neu. Bleibt es dabei, wenden Sie sich an die
            Administration.
          </p>
        </div>
        <JSXNeuladen />
      </main>
    );
  }
}

function JSXNeuladen(): JSX.Element {
  return (
    <button
      className="knopf knopf--haupt"
      type="button"
      onClick={() => {
        window.location.reload();
      }}
    >
      Seite neu laden
    </button>
  );
}
